document.addEventListener("DOMContentLoaded", function () {
	function toggleSwiperClass($element) {
		$element.toggleClass("swiper");
		$element.find(".sw-wrapper").toggleClass("swiper-wrapper");
		$element.find(".sw-slide").toggleClass("swiper-slide");
		$element.find(".sw-scrollbar").toggleClass("swiper-scrollbar");
		$element.find(".sw-prev").toggleClass("swiper-button-prev");
		$element.find(".sw-next").toggleClass("swiper-button-next");
		$element.find(".sw-pagination").toggleClass("swiper-pagination");
	}

	function responsiveSwiper($element, options, breakpoint) {
		let init = false;
		let swiper;

		function swiperCard() {
			if (window.innerWidth < breakpoint) {
				if (!init) {
					init = true;
					toggleSwiperClass($element);
					swiper = new Swiper($element[0], options);
				}
			} else if (init) {
				swiper.destroy();
				init = false;
				toggleSwiperClass($element);
			}
		}

		swiperCard();

		window.addEventListener("resize", swiperCard);
	}

	const swiperSlide = (selector, options = {}) => {
		const $sliders = $(selector);

		if (!$sliders.length) {
			return;
		}

		$sliders.each(function () {
			new Swiper($(this)[0], options);
		});
	};

	(function () {
		const baseConfig = {
			slidesPerView: 2.25,
			centeredSlides: false,
			loop: false,
			spaceBetween: 25,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				750: { slidesPerView: 3, spaceBetween: 20 },
			},
		}
		swiperSlide(".section-slideshow-container .swiper-slider-list.num_3", baseConfig);
        
        baseConfig.breakpoints["750"] = { slidesPerView: 4, spaceBetween: 20 }
        swiperSlide(".section-slideshow-container .swiper-slider-list.num_4", baseConfig);

        baseConfig.breakpoints["750"] = { slidesPerView: 5, spaceBetween: 20 }
        swiperSlide(".section-slideshow-container .swiper-slider-list.num_5", baseConfig);
    })();
})
